const accountDashboard =
`/* Account dashboard - Table cell - scrip name - default */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"] td[data-label="Symbol"] div[class^="title"] {
  background-color: var(--tv-color-toolbar-button-background-hover);
}

/* Account dashboard - Table cell - scrip name - selected  */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"][data-row-linked="true"] td[data-label="Symbol"]:first-child {
  box-shadow: inset 3px 0 0 0 var(--tv-color-toolbar-button-text-active);
}

/* Account dashboard - Table cell - scrip name - hover, selected  */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"]:hover td[data-label="Symbol"] div[class^="title"],
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"][data-row-linked="true"] td[data-label="Symbol"] div[class^="title"],
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"]:hover td[data-label="Segment"] div[class^="title"],
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"][data-row-linked="true"] td[data-label="Segment"] div[class^="title"] {
  background-color: var(--tv-color-toolbar-button-text-active) !important;
  color: var(--tv-color-item-active-text) !important;
}

/* Account dashboard - Table row - modify, cancel icon  */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"] td[class^="ka-cell"]+td[class^="ka-cell"]>div[class^="ka-cell-text"][class*=" cellContent"][class*=" capitalize"] div[class^="buttons"] div[data-role="button"]:hover {
  --tv-color-toolbar-button-background-hover: var(--tv-color-toolbar-button-background-hover);
  color: var(--tv-color-label-primary-text) !important;
  background-color: var(--tv-color-toolbar-button-background-hover) !important;
}

/* Account dashboard - Table cell - Buy label */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"] td[data-label="Side"] span[class^="blue"] {
  color: var(--tv-color-toolbar-button-buy-active);
}

/* Account dashboard - Table cell - Sell label */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"] td[data-label="Side"] span[class^="red"] {
  color: var(--tv-color-toolbar-button-sell-active);
}

/* Account dashboard - Table row - hover state */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"]:hover {
  background-color: var(--tv-color-toolbar-button-background-hover);
}

/* Account dashboard - Table row - hover state */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"]:hover td:first-child,
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"]:hover td:last-child {
  background-color: var(--tv-color-toolbar-button-background-hover);
}

/* Account dashboard - Table row  */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"] {
  border: none;
  border-bottom: 1px solid var(--tv-color-toolbar-button-text-active-hover);
}

/* Account dashboard - secondary buttons - order status filter tabs - selected */
div[id="id_account-manager-page-filter-tabs_orders_tablist"] button[class^="square-tab-button"][class*=" selected"],
div[id="id_account-manager-page-filter-tabs_orders_tablist"] button[class^="square-tab-button"][class*=" selected"]:hover {
  background-color: var(--tv-color-toolbar-button-text-active) !important;
  color: var(--tv-color-item-active-text) !important;
}

/* Account dashboard - secondary buttons - order status filter tabs */
div[id="id_account-manager-page-filter-tabs_orders_tablist"] button[class^="square-tab-button"]:hover {
  background-color: var(--tv-color-toolbar-button-text-active-hover);
}

/* Account dashboard - secondary buttons - order status filter tabs */
div[id="id_account-manager-page-filter-tabs_orders_tablist"] button[class^="square-tab-button"] {
  color: var(--tv-color-label-primary-text) !important;
}

/* Account dashboard - positions , orders, holding table */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"] td[class^="ka-cell"]+td[class^="ka-cell"]>div[class^="ka-cell-text"][class*=" cellContent"][class*=" capitalize"] {
  max-width: 100% !important;
}

/* Account dashboard - Account text */
div[class^="accountManager"]>div[class*="js-account-manager-header"] span[class*="content"] {
  color: var(--tv-color-label-primary-text) !important;
}

/* Account dashboard - Pnl Holdings/ Pnl Position value text */
div[class^="accountManager"]>div[class*="js-account-manager-header"] div[class^="accountSummaryRow"] div[class^="accountSummaryField"] div[class^="value"] {
  color: var(--tv-color-label-primary-text) !important;
}

/* Account dashboard - Pnl Holdings/ Pnl Position label text */
div[class^="accountManager"]>div[class*="js-account-manager-header"] div[class^="accountSummaryRow"] div[class^="accountSummaryField"] div[class^="title"] {
  color: var(--tv-color-label-secondary-text) !important;
}

/* Account dashboard - Minimize/Collapse button on top */
div[id="footer-chart-panel"] div[class^="buttons"] button[data-name="toggle-visibility-button"],
div[id="footer-chart-panel"] div[class^="buttons"] button[data-name="toggle-maximize-button"] {
  color: var(--tv-color-label-primary-text) !important;
}

/* Account dashboard - Minimize/Collapse button on top - hover */
div[id="footer-chart-panel"] div[class^="buttons"] button[data-name="toggle-visibility-button"]:hover,
div[id="footer-chart-panel"] div[class^="buttons"] button[data-name="toggle-maximize-button"]:hover {
  color: var(--tv-color-toolbar-button-text-active) !important;
}

/* Account dashboard - Order/Position Table - Header cell content */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"] th[class^="ka-thead-cell"] div[class^="ka-thead-cell-content"][class*="headCellContent"] {
  color: var(--tv-color-label-secondary-text);
}

/* Account dashboard - Order/Position Table - Row cell content */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"] td[class^="ka-cell"]>div[class^="ka-cell-text"][class*=" cellContent"] {
  color: var(--tv-color-label-primary-text) !important;
}

/* Account dashboard - Table cell - Order status Working label */
div[class^="accountManager"] div[class^="page"] table[class^="ka-table"] tbody[class^="ka-tbody"] tr[class^="ka-tr"] td[data-label="Status"] span[class^="blue"] {
  color: var(--tv-color-toolbar-button-buy-active);
}

/* Account dashboard - Dashboard header text */
div[id="footer-chart-panel"] button[data-name="paper_trading"] {
  color: var(--tv-color-toolbar-button-text-active) !important;
}

/* Account dashboard - Dashboard trade button hover */
div[id="footer-chart-panel"] button[data-name="trade-panel-button"]:hover {
  background-color: var(--tv-color-toolbar-button-background-hover);
}

/* Account dashboard - Dashboard terminal dropdown */
div[class^="accountManager"] div[data-name="terminal-dropdown"][class*=" isOpened"]:before {
  background-color: var(--tv-color-toolbar-button-background-hover) !important
}`;

export default accountDashboard;
